import axios from 'axios';

export default async () => {
  if (process.env.NODE_ENV === 'development') {
    const jsonConfig = require('./dev.json');

    return jsonConfig;
  } else {
    return axios.get('/config.json').then(res => {
      return res.data;
    });
  }
};
